if (!customElements.get('product-form')) {
  class ProductForm extends HTMLElement {
    constructor() {
      super();

      if (this.hasChildNodes()) {
        this.init();
      }
    }

    init() {
      this.setAttribute('data-3dmark-subtotal-initialized', 'true');

      this.form = this.querySelector('.js-product-form');
      this.section = this.closest('.js-product') || document;

      if (!this.form) return;

      this.cartDrawer = document.querySelector('cart-drawer');
      this.submitBtn = this.querySelector('[name="add"]');
      this._priceCache = new Map();

      if (theme.settings.afterAtc !== 'no-js') {
        this.form.addEventListener('submit', this.handleSubmit.bind(this));
      }

      this.form.addEventListener('change', () => {
        this.updateSubtotal();
      });

      if (this.section) {
        this.section.addEventListener('change', (event) => {
          if (
            event.target &&
            event.target.matches &&
            event.target.matches('[data-addon-checkbox]')
          ) {
            this.updateSubtotal();
          }
        });

        this.section.addEventListener('on:variant:change', () => {
          this.updateSubtotal();
        });
      }

      const idInput = this.form.querySelector('input[name="id"]');

      if (idInput) {
        const observer = new MutationObserver(() => {
          this.updateSubtotal();
        });

        observer.observe(idInput, {
          attributes: true,
          attributeFilter: ['value']
        });

        this._variantIdObserver = observer;
      }

      this.updateSubtotal();
    }

    async handleSubmit(evt) {
      if (evt.target.id === 'product-signup_form') return;

      evt.preventDefault();

      if (this.submitBtn.getAttribute('aria-disabled') === 'true') return;

      if (theme.settings.vibrateOnATC && window.navigator.vibrate) {
        window.navigator.vibrate(100);
      }

      this.errorMsg = null;
      this.setErrorMsgState();

      this.submitBtn.setAttribute('aria-disabled', 'true');
      this.submitBtn.classList.add('is-loading');

    const formData = new FormData(this.form);

    const variantIdInput = this.form.querySelector('input[name="id"]');

    const originalVariantId = variantIdInput
      ? String(variantIdInput.value)
      : String(formData.get('id') || '');

    const mainQuantity =
      parseInt(formData.get('quantity'), 10) || 1;

    /**
     * 3DMARK：
     * 強制主商品 FormData 使用目前主商品真正選取的 Variant ID。
     * 避免加購 Variant selector 或其他 change event
     * 影響主商品送出的 Variant。
     */
    if (originalVariantId) {
      formData.set('id', originalVariantId);
    }

      const addonChecks = this.section?.querySelectorAll('[data-addon-checkbox]:checked') || [];
      const hasSelectedAddons = addonChecks.length > 0;

      const bundleId = hasSelectedAddons
        ? `3dmark-${Date.now()}-${Math.random().toString(36).slice(2, 8)}`
        : '';

      /**
       * 3DMARK：
       * 主商品也寫入 bundle id。
       * 這樣加購品可以用 Parent bundle id 找回對應主商品。
       */
      if (bundleId) {
        formData.append('properties[_3dmark_bundle_id]', bundleId);
      }

      const shouldRedirectToCart = theme.settings.afterAtc === 'page';
      const quickAddDrawer = this.closest('quick-add-drawer');

      let sections = 'cart-icon-bubble';

      if (this.cartDrawer) {
        const cartDrawerSection = this.cartDrawer.closest('.shopify-section');

        if (cartDrawerSection) {
          sections += `,${cartDrawerSection.id.replace('shopify-section-', '')}`;
        }
      }

      formData.append('sections_url', window.location.pathname);
      formData.append('sections', sections);

      const fetchRequestOpts = {
        method: 'POST',
        headers: {
          Accept: 'application/javascript',
          'X-Requested-With': 'XMLHttpRequest'
        },
        body: formData
      };

      try {
        const oldCartResponse = await fetch(`${theme.routes.cart}.js`);

        if (!oldCartResponse.ok) {
          throw new Error(oldCartResponse.status);
        }

        const oldCartData = await oldCartResponse.json();

        const response = await fetch(theme.routes.cartAdd, fetchRequestOpts);
        const data = await response.json();

        let error = typeof data.description === 'string' ? data.description : data.message;

        if (data.errors && typeof data.errors === 'object') {
          error = Object.entries(data.errors).map((item) => item[1].join(', '));
        }

        if (data.status) {
          this.setErrorMsgState(error);
        }

        if (!response.ok) {
          throw new Error(response.status);
        }

        if (!shouldRedirectToCart) {
          ProductForm.updateCartIcon(data);

          if (quickAddDrawer) {
            quickAddDrawer.addedToCart();
          }

          setTimeout(() => {
            if (this.cartDrawer) {
              this.cartDrawer.renderContents(
                data,
                !quickAddDrawer && theme.settings.afterAtc === 'drawer'
              );
            } else if (window.location.pathname === theme.routes.cart) {
              const cartItems = document.querySelector('cart-items');

              if (cartItems) {
                if (cartItems.dataset.empty === 'true') {
                  window.location.reload();
                } else {
                  cartItems.refresh();
                }
              }
            }
          }, 700);
        }

        // 加購品加入前，先暫停 cart guard，避免剛加入就被誤刪
        window.threeDMarkAddonCartGuardPausedUntil = Date.now() + 10000;

        await this.addSelectedAddons({
          formData,
          sections,
          shouldRedirectToCart,
          parentLineKey: String(data.key || ''),
          parentVariantId: String(data.variant_id || formData.get('id') || ''),
          parentQuantity: mainQuantity,
          parentBundleId: bundleId
        });

        if (!shouldRedirectToCart) {
          if (this.cartDrawer && typeof this.cartDrawer.refresh === 'function') {
            this.cartDrawer.refresh(true);
          } else if (window.location.pathname === theme.routes.cart) {
            window.location.reload();
          }
        }

        if (shouldRedirectToCart) {
          setTimeout(() => {
            window.location.href = theme.routes.cart;
          }, 300);
        }

        this.updateSubtotal();

        const newCartResponse = await fetch(`${theme.routes.cart}.js`);

        if (!newCartResponse.ok) {
          throw new Error(newCartResponse.status);
        }

        const newCartData = await newCartResponse.json();

        const itemInOldCart = oldCartData.items.filter((item) => {
          return item.variant_id === data.variant_id;
        })[0];

        if (itemInOldCart) {
          this.dispatchEvent(
            new CustomEvent('on:line-item:change', {
              bubbles: true,
              detail: {
                cart: newCartData,
                variantId: data.variant_id,
                oldQuantity: itemInOldCart.quantity,
                newQuantity:
                  itemInOldCart.quantity === data.quantity
                    ? itemInOldCart.quantity
                    : data.quantity
              }
            })
          );
        } else {
          this.dispatchEvent(
            new CustomEvent('on:cart:add', {
              bubbles: true,
              detail: {
                cart: newCartData,
                variantId: data.variant_id
              }
            })
          );
        }
      } catch (error) {
        console.log(error);

        this.dispatchEvent(
          new CustomEvent('on:cart:error', {
            bubbles: true,
            detail: {
              error: this.errorMsg?.textContent
            }
          })
        );

        if (this.cartDrawer) {
          this.cartDrawer.refresh(true);
        }
      } finally {
        this.submitBtn.classList.add('is-success');
        this.submitBtn.removeAttribute('aria-disabled');

        setTimeout(() => {
          this.submitBtn.classList.remove('is-loading');
          this.submitBtn.classList.remove('is-success');
        }, 1400);
      }
    }

    async addSelectedAddons({
      formData,
      sections,
      shouldRedirectToCart,
      parentLineKey,
      parentVariantId,
      parentQuantity,
      parentBundleId
    }) {
      const addonChecks = this.section?.querySelectorAll('[data-addon-checkbox]:checked') || [];

      if (!addonChecks.length) return false;

      const addonItems = [];

      const productTitleEl = this.closest('.product')?.querySelector('.product-title');
      const parentTitle = productTitleEl ? productTitleEl.textContent.trim() : 'Main product';

      const mainVariantId = String(parentVariantId || formData.get('id') || '');
      const mainLineKey = String(parentLineKey || mainVariantId || '');
      const mainBundleId = String(parentBundleId || mainLineKey || mainVariantId || '');

      console.group('🛒 3DMARK ADDON PROCESS');
      console.log('Checked addon checkboxes:', addonChecks.length);
      console.log('Main variant id:', mainVariantId);
      console.log('Main line key:', mainLineKey);
      console.log('Main bundle id:', mainBundleId);

for (const checkbox of addonChecks) {
  const parentProductId =
    checkbox.dataset.parentProductId ||
    '';

  const checkboxParentVariantId =
    checkbox.dataset.parentVariantId || '';

  const finalParentVariantId = String(
    mainVariantId ||
    checkboxParentVariantId ||
    ''
  );

  const packQuantity =
    parseInt(
      checkbox.dataset.addonPackQuantity || '1',
      10
    ) || 1;

  /**
   * ===== Pack 模式 =====
   */
  if (
    packQuantity > 1 &&
    checkbox.dataset.addonPackVariants
  ) {
    let packVariants = [];

    try {
      packVariants =
        JSON.parse(
          checkbox.dataset.addonPackVariants
        );
    } catch (error) {
      console.error(
        '[3DMARK] Invalid addon pack variants',
        error
      );

      continue;
    }

    /**
     * 將相同 Variant 合併數量。
     *
     * 例如：
     * 紅、紅、藍、白
     *
     * 會變：
     * 紅 x2
     * 藍 x1
     * 白 x1
     */
    const variantQuantityMap = new Map();

    packVariants.forEach((variant) => {
      const variantId = String(variant.id || '');

      if (!this.isValidVariantId(variantId)) {
        return;
      }

      const currentQuantity =
        variantQuantityMap.get(variantId) || 0;

      variantQuantityMap.set(
        variantId,
        currentQuantity + 1
      );
    });

    for (const [
      addonVariantId,
      quantity
    ] of variantQuantityMap.entries()) {
      const addonUniqueKey =
        `${mainBundleId}-${addonVariantId}-` +
        `${Date.now()}-` +
        `${Math.random()
          .toString(36)
          .slice(2, 8)}`;

      addonItems.push({
        id: parseInt(addonVariantId, 10),

        quantity,

        properties: {
          '_addon_only': 'true',

          '_parent_bundle_id':
            mainBundleId,

          '_parent_line_key':
            mainLineKey,

          '_parent_product_id':
            String(parentProductId),

          '_parent_variant_id':
            String(finalParentVariantId),

          '_addon_unique_key':
            addonUniqueKey,

          '_addon_for':
            parentTitle,

          '_addon_pack_quantity':
            String(packQuantity)
        }
      });
    }

    continue;
  }

  /**
   * ===== 一般單件加購 =====
   */

  const addonVariantId =
    checkbox.dataset.variantId;

  if (!this.isValidVariantId(addonVariantId)) {
    console.warn(
      'Invalid addon variant id:',
      addonVariantId
    );

    continue;
  }

  const requestedAddonQuantity =
    parseInt(
      checkbox.dataset.addonQuantity || '1',
      10
    ) || 1;

  const addonQuantity =
    requestedAddonQuantity;

  const addonUniqueKey =
    `${mainBundleId}-${addonVariantId}-` +
    `${Date.now()}-` +
    `${Math.random()
      .toString(36)
      .slice(2, 8)}`;

  addonItems.push({
    id: parseInt(addonVariantId, 10),

    quantity: addonQuantity,

    properties: {
      '_addon_only': 'true',

      '_parent_bundle_id':
        mainBundleId,

      '_parent_line_key':
        mainLineKey,

      '_parent_product_id':
        String(parentProductId),

      '_parent_variant_id':
        String(finalParentVariantId),

      '_addon_unique_key':
        addonUniqueKey,

      '_addon_for':
        parentTitle
    }
  });
}

      if (!addonItems.length) {
        console.groupEnd();
        return false;
      }

      const addonPayload = {
        items: addonItems,
        sections,
        sections_url: window.location.pathname
      };

      try {
        console.log('Sending batch addon payload:', addonPayload);

        const addonResponse = await fetch(theme.routes.cartAdd, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            Accept: 'application/json',
            'X-Requested-With': 'XMLHttpRequest'
          },
          body: JSON.stringify(addonPayload)
        });

        const addonData = await addonResponse.json();

        if (!addonResponse.ok) {
          console.error('Batch addon add failed:', addonData);
          throw new Error(addonData.message || addonData.description || addonResponse.status);
        }

        console.log('Addons added successfully:', addonData);

        ProductForm.updateCartIcon(addonData);

        if (this.cartDrawer && !shouldRedirectToCart) {
          this.cartDrawer.renderContents(addonData, false);
        }

        console.groupEnd();

        return true;
      } catch (error) {
        console.error('Addon batch add error:', error);
        console.groupEnd();

        return false;
      }
    }

    async normalizeAddonItems() {
      // 暫時停用加購品自動清理。
      return false;
    }

    static updateCartIcon(response) {
      const cartIconBubble = document.getElementById('cart-icon-bubble');

      if (
        cartIconBubble &&
        response &&
        response.sections &&
        response.sections['cart-icon-bubble']
      ) {
        cartIconBubble.innerHTML = response.sections['cart-icon-bubble'];
      }
    }

    setErrorMsgState(error = false) {
      this.errorMsg = this.errorMsg || this.querySelector('.js-form-error');

      if (!this.errorMsg) return;

      this.errorMsg.hidden = !error;

      if (error) {
        this.errorMsg.innerHTML = '';

        const errorArray = Array.isArray(error) ? error : [error];

        errorArray.forEach((err, index) => {
          if (index > 0) {
            this.errorMsg.insertAdjacentHTML('beforeend', '<br>');
          }

          this.errorMsg.insertAdjacentText('beforeend', err);
        });
      }
    }

    formatMoney(cents) {
      try {
        if (window.Shopify && Shopify.formatMoney) {
          const fmt =
            (window.theme && (theme.moneyFormat || theme.settings?.moneyFormat)) || undefined;

          return Shopify.formatMoney(Math.round(cents), fmt);
        }
      } catch (error) {}

      const currency =
        (window.Shopify && Shopify.currency && Shopify.currency.active) || 'USD';

      const locale = document.documentElement.lang || navigator.language || 'en-US';

      return new Intl.NumberFormat(locale, {
        style: 'currency',
        currency
      }).format((cents || 0) / 100);
    }

    isValidVariantId(variantId) {
      if (variantId == null) return false;

      const str = String(variantId).trim();

      if (!/^\d+$/.test(str)) return false;

      const n = parseInt(str, 10);

      return Number.isFinite(n) && n > 0;
    }

    getAddonQuantityForCheckbox(checkbox, maxQuantity) {
      const maxAddonQuantity = parseInt(maxQuantity, 10) || 1;
      const requestedAddonQuantity = parseInt(checkbox.dataset.addonQuantity || '1', 10) || 1;

      return Math.min(requestedAddonQuantity, maxAddonQuantity);
    }

    async getVariantPriceCents(variantId) {
      if (!this.isValidVariantId(variantId)) {
        return 0;
      }

      if (this._priceCache.has(variantId)) {
        return this._priceCache.get(variantId);
      }

      try {
        const res = await fetch(`/variants/${variantId}.json`);

        if (!res.ok) {
          console.warn('[3DMARK-SUBTOTAL] fetch failed', variantId, res.status);
          throw new Error(res.status);
        }

        const json = await res.json();

        const priceStr =
          json &&
          json.product_variant &&
          (
            json.product_variant.price ||
            json.product_variant.price_amount ||
            json.product_variant.priceV2?.amount
          );

        const cents = Math.round(parseFloat(priceStr) * 100);

        this._priceCache.set(variantId, cents);

        return cents;
      } catch (error) {
        console.warn('[3DMARK-SUBTOTAL] Failed to load variant price', variantId, error);
        return 0;
      }
    }

    async updateSubtotal() {
      const root = this.section || this;
      const target = root.querySelector('[data-3dmark-subtotal]');

      if (!target) return;

      const qtyInput = this.form.querySelector('[name="quantity"]');
      const qty = parseInt(qtyInput ? qtyInput.value : '1', 10) || 1;

      const variantIdInput = this.form.querySelector('input[name="id"]');
      const mainVariantId = variantIdInput ? variantIdInput.value : '';

      let mainPrice = 0;

      if (this.isValidVariantId(mainVariantId)) {
        mainPrice = await this.getVariantPriceCents(mainVariantId);
      }

      let addonsTotal = 0;
      const addonChecks = root.querySelectorAll('[data-addon-checkbox]:checked');

for (const checkbox of addonChecks) {
  const packQuantity =
    parseInt(
      checkbox.dataset.addonPackQuantity || '1',
      10
    ) || 1;

  /**
   * Pack 加購
   */
  if (
    packQuantity > 1 &&
    checkbox.dataset.addonPackVariants
  ) {
    try {
      const packVariants =
        JSON.parse(
          checkbox.dataset.addonPackVariants
        );

      for (const variant of packVariants) {
        const addonId =
          String(variant.id || '');

        if (
          this.isValidVariantId(addonId)
        ) {
          const price =
            await this.getVariantPriceCents(
              addonId
            );

          addonsTotal += price;
        }
      }
    } catch (error) {
      console.error(
        '[3DMARK] Failed to calculate pack subtotal',
        error
      );
    }

    continue;
  }

  /**
   * 一般加購
   */
  const addonId =
    checkbox.dataset.variantId;

  if (
    this.isValidVariantId(addonId)
  ) {
    const price =
      await this.getVariantPriceCents(
        addonId
      );

    const addonQuantity =
      parseInt(
        checkbox.dataset.addonQuantity ||
          '1',
        10
      ) || 1;

    addonsTotal +=
      price * addonQuantity;
  }
}

      const subtotalCents = mainPrice * qty + addonsTotal;

      target.textContent = this.formatMoney(subtotalCents);
    }
  }

  customElements.define('product-form', ProductForm);
}

/**
 * 3dmark:
 * 如果主題已經先定義 product-form，這段只補小計功能。
 */
(function enhance3DMarkSubtotal() {
  if (!customElements.get('product-form')) return;

  document.addEventListener('DOMContentLoaded', () => {
    document.querySelectorAll('product-form').forEach((root) => {
      if (root.dataset.subtotalEnhanced === 'true') return;
      if (root.hasAttribute('data-3dmark-subtotal-initialized')) return;

      root.dataset.subtotalEnhanced = 'true';

      const form = root.querySelector('.js-product-form');
      const section = root.closest('.js-product') || document;

      if (!form) return;

      const priceCache = new Map();

      const isValidVariantId = (variantId) => {
        if (variantId == null) return false;

        const str = String(variantId).trim();

        if (!/^\d+$/.test(str)) return false;

        const n = parseInt(str, 10);

        return Number.isFinite(n) && n > 0;
      };

      const formatMoney = (cents) => {
        try {
          if (window.Shopify && Shopify.formatMoney) {
            const fmt =
              (window.theme && (theme.moneyFormat || theme.settings?.moneyFormat)) || undefined;

            return Shopify.formatMoney(Math.round(cents), fmt);
          }
        } catch (error) {}

        const currency =
          (window.Shopify && Shopify.currency && Shopify.currency.active) || 'USD';

        const locale = document.documentElement.lang || navigator.language || 'en-US';

        return new Intl.NumberFormat(locale, {
          style: 'currency',
          currency
        }).format((cents || 0) / 100);
      };

      const getAddonQuantityForCheckbox = (checkbox, maxQuantity) => {
        const maxAddonQuantity = parseInt(maxQuantity, 10) || 1;
        const requestedAddonQuantity = parseInt(checkbox.dataset.addonQuantity || '1', 10) || 1;

        return Math.min(requestedAddonQuantity, maxAddonQuantity);
      };

      const getVariantPriceCents = async (variantId) => {
        if (!isValidVariantId(variantId)) {
          return 0;
        }

        if (priceCache.has(variantId)) {
          return priceCache.get(variantId);
        }

        try {
          const res = await fetch(`/variants/${variantId}.json`);

          if (!res.ok) {
            console.warn('[3DMARK-SUBTOTAL][FALLBACK] fetch failed', variantId, res.status);
            throw new Error(res.status);
          }

          const json = await res.json();

          const priceStr =
            json &&
            json.product_variant &&
            (
              json.product_variant.price ||
              json.product_variant.price_amount ||
              json.product_variant.priceV2?.amount
            );

          const cents = Math.round(parseFloat(priceStr) * 100);

          priceCache.set(variantId, cents);

          return cents;
        } catch (error) {
          console.warn(
            '[3DMARK-SUBTOTAL][FALLBACK] Failed to load variant price',
            variantId,
            error
          );

          return 0;
        }
      };

      const updateSubtotal = async () => {
        const target = (section || root).querySelector('[data-3dmark-subtotal]');

        if (!target) return;

        const qtyInput = form.querySelector('[name="quantity"]');
        const qty = parseInt(qtyInput ? qtyInput.value : '1', 10) || 1;

        const variantIdInput = form.querySelector('input[name="id"]');
        const mainVariantId = variantIdInput ? variantIdInput.value : '';

        let mainPrice = 0;

        if (isValidVariantId(mainVariantId)) {
          mainPrice = await getVariantPriceCents(mainVariantId);
        }

        let addonsTotal = 0;
        const addonChecks = (section || root).querySelectorAll('[data-addon-checkbox]:checked');

for (const checkbox of addonChecks) {
  const packQuantity =
    parseInt(
      checkbox.dataset.addonPackQuantity || '1',
      10
    ) || 1;

  /**
   * Pack 加購
   */
  if (
    packQuantity > 1 &&
    checkbox.dataset.addonPackVariants
  ) {
    try {
      const packVariants =
        JSON.parse(
          checkbox.dataset.addonPackVariants
        );

      for (const variant of packVariants) {
        const addonId =
          String(variant.id || '');

        if (isValidVariantId(addonId)) {
          const price =
            await getVariantPriceCents(
              addonId
            );

          addonsTotal += price;
        }
      }
    } catch (error) {
      console.error(
        '[3DMARK-SUBTOTAL][FALLBACK] Failed to calculate pack subtotal',
        error
      );
    }

    continue;
  }

  /**
   * 一般加購
   */
  const addonId =
    checkbox.dataset.variantId;

  if (isValidVariantId(addonId)) {
    const price =
      await getVariantPriceCents(
        addonId
      );

    const addonQuantity =
      parseInt(
        checkbox.dataset.addonQuantity || '1',
        10
      ) || 1;

    addonsTotal +=
      price * addonQuantity;
  }
}

        const subtotalCents = mainPrice * qty + addonsTotal;

        target.textContent = formatMoney(subtotalCents);
      };

      form.addEventListener('change', updateSubtotal);

      if (section) {
        section.addEventListener('change', (event) => {
          if (
            event.target &&
            event.target.matches &&
            event.target.matches('[data-addon-checkbox]')
          ) {
            updateSubtotal();
          }
        });

        section.addEventListener('on:variant:change', updateSubtotal);
      }

      const idInput = form.querySelector('input[name="id"]');

      if (idInput) {
        idInput.addEventListener('change', updateSubtotal);
      }

      updateSubtotal();
    });
  });
})();